export interface ISimplePresentationRunnerController {
    finish: () => void,
    setSkipCallback: (skipCallback?: Function) => void
}

export interface ISimplePresentation {
    shouldRun(): boolean;

    start(controller: ISimplePresentationRunnerController): void;
}

export class SimplePresentationRunner {
    public static run(presentations: ISimplePresentation[], finishCallback: Function, setSkipCallback: (skipCallback?: Function) => void): void {
        const localPresentations = presentations.concat();
        const presentation: ISimplePresentation | undefined = localPresentations.shift();
        if (presentation === undefined) {
            finishCallback();
        } else {
            if (presentation.shouldRun()) {
                presentation.start({
                    finish: () => SimplePresentationRunner.run(localPresentations, finishCallback, setSkipCallback),
                    setSkipCallback: setSkipCallback
                });
            } else {
                SimplePresentationRunner.run(localPresentations, finishCallback, setSkipCallback);
            }
        }
    }
}